import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { hapticImpact } from '../utils/haptic'

/**
 * Переход на публичный профиль игрока по slug — внутренний экран
 * /profile/:slug (GET /api/profile/{slug}/), не внешняя ссылка.
 *
 * slug приходит во всех ответах API рядом с именем и аватаром игрока
 * (в кейсбатлах — user_slug): строка 32 символов [a-z0-9] либо null.
 * null — ссылки нет (игрок удалён из базы или демо-данные), клик игнорируется.
 *
 * Аватары часто лежат внутри кликабельных карточек, поэтому обработчик
 * останавливает всплытие — родительская карточка не сработает.
 */
const useOpenProfile = () => {
  const navigate = useNavigate()

  return useCallback((event, slug) => {
    if (!slug) return
    event?.stopPropagation?.()
    hapticImpact('light')
    navigate(`/profile/${slug}`)
  }, [navigate])
}

export default useOpenProfile
